export const SLIDER_DATA = [
  { description: `<span>Spoiler alert: </span> you're going to love what we find ` },
  { description: `<span>Pro tip: </span> find it before your friends do` },
  { description: `<span>Life hack: </span> window shop from your pj's w/qatch` },
  { description: `<span>fyi: </span> you might get tired of saying “thx, found it from Qatch”` }
]

export const SMS_LIST = [
  {
    title: 'MESSAGE',
    subTitle: 'Rachel',
    message: `I'm obsessed with this site! I love having my own profile where I can see all of my Qatches and what's trending!`,
    icon: './assets/img/icons/sms.png',
    time: 'now'
  },
  {
    title: 'MESSAGE',
    subTitle: 'Lina',
    message: `Ooo I love all of these!!! You're gonna make me spend all my money before Christmas!!`,
    icon: './assets/img/icons/sms.png',
    time: 'now'
  },
  {
    title: 'MESSAGE',
    subTitle: 'Betty',
    message: `It's so fun scrolling through and seeing all of the styles that are trending right now!`,
    icon: './assets/img/icons/sms.png',
    time: 'now'
  },
  {
    title: 'MESSAGE',
    subTitle: 'Carole',
    message: `Qatch is the service I never knew I needed - they're always spot on with their recommendations!`,
    icon: './assets/img/icons/sms.png',
    time: 'now'
  },
  {
    title: 'MESSAGE',
    subTitle: 'Blake',
    message: `Qatch makes it SUPER easy for me to stay on trend and find pieces that are outside of my comfort zone.`,
    icon: './assets/img/icons/sms.png',
    time: 'now'
  },
  {
    title: 'MESSAGE',
    subTitle: 'Yvanna',
    message: `I was LITERALLY shopping for a leather jacket today!!! I couldn't find one but the one you sent is PERFECT`,
    icon: './assets/img/icons/sms.png',
    time: 'now'
  },
  {
    title: 'MESSAGE',
    subTitle: 'Rebecca',
    message: `LOVE this Banana Republic blouse, just bought 2! Thanks for helping me find it!`,
    icon: './assets/img/icons/sms.png',
    time: 'now'
  },
  {
    title: 'MESSAGE',
    subTitle: 'Alexa',
    message: `I'm looooving lavender please send more options in that color! Y'all are nailing these looks!`,
    icon: './assets/img/icons/sms.png',
    time: 'now'
  },
  {
    title: 'MESSAGE',
    subTitle: 'Sevara',
    message: `The new website LOOKS AMAZING! I love how neat and efficient it is and that I can see my faves in one place!`,
    icon: './assets/img/icons/sms.png',
    time: 'now'
  },
  {
    title: 'MESSAGE',
    subTitle: 'Bridget',
    message: `Girlfriend you are killing it!! Thank you so much so the recommendations❤️❤️❤️`,
    icon: './assets/img/icons/sms.png',
    time: 'now'
  },
  {
    title: 'MESSAGE',
    subTitle: 'Alexandra',
    message: `I love this so much, thank you for the recommendations! I am a huge advocate for sustainable fashion 😍`,
    icon: './assets/img/icons/sms.png',
    time: 'now'
  },
  {
    title: 'MESSAGE',
    subTitle: 'Lina',
    message: `Hi stylist! Can you help me find a jacket? I have a classic leather but I'm looking for something that is funky 💥`,
    icon: './assets/img/icons/sms.png',
    time: 'now'
  },
  {
    title: 'MESSAGE',
    subTitle: 'Annalyce',
    message: `Oooh that Anisia dress is 🔥 the gray glitter dress too!! Thanks so much for recommending them 😍`,
    icon: './assets/img/icons/sms.png',
    time: 'now'
  }
]

export const BRAND_LOGOS_1 = [
  { img: 'brands-logos%2Frevolve.svg' },
  { img: 'brands-logos%2Fmejuri.svg' },
  { img: 'brands-logos%2Fubeauty.svg' },
  { img: 'brands-logos%2Fnike.svg' },
  { img: 'brands-logos%2Fandie.svg' },
  { img: 'brands-logos%2Frevolve.svg' }
]

export const BRAND_LOGOS_2 = [
  { img: 'brands-logos%2Fforever21.svg' },
  { img: 'brands-logos%2Faje.svg' },
  { img: 'brands-logos%2Ffrank_and_eileen.svg', scale:'' },
  { img: 'brands-logos%2Fprincess_polly.svg', scale:'' },
  { img: 'brands-logos%2Fpistola.png' },
  { img: 'brands-logos%2Faje.svg' }
]

export const OUTFIT_BLOCK = {
  header: { title: 'Where Cute Outfits Come To You', subTitle: 'Here’s what to expect each week from your stylist' },
  cards: [{
    heading: "Tell Us About Yourself",
    subheading: "& we'll send curated style inspo your way",
    bgcolor: "#c6badf",
    url: "3_3.png"
  },
  {
    heading: "From New To Sale",
    subheading: "we do the browsing for you across 150+ sites",
    bgcolor: "#d3dfe8",
    url: "3_5.png"
  },
  {
    heading: "One Text Conversation",
    subheading: "with endless style of options",
    bgcolor: "#dcd3ef",
    url: "3_7.png"
  }]
}